import { useCallback } from 'react';
import { NavigateOptions, useRouter } from '@tanstack/react-router';

export function useGoBack(defaultRoute?: NavigateOptions) {
  const router = useRouter();

  // Сначала пробуем наш роутер
  // Потом браузерный
  // Потом переданный фоллбек
  // Потом отправляем просто в корень.
  return useCallback(() => {
    if (router.history.canGoBack()) {
      router.history.back();
    } else if (history.length > 0) {
      history.back();
    } else if (defaultRoute) {
      router.navigate(defaultRoute);
    } else {
      router.navigate({ to: '/', from: '/' });
    }
  }, [defaultRoute, router]);
}
